import { ISessionSelectorContext, ISessionTreeNode } from "@webapp/sessions/models/session-tree.model";
import { Session } from "@webapp/sessions/models/sessions.model";
import { getSessionAndOneLevelChildren } from "@webapp/sessions/utils/utils";
import { SessionSelectorUtilsService } from "../session-selector-utils.service";
import { AbstractSessionTreeBuilder } from "./abstract-session-tree-builder";

export class ParentAlignmentSessionTreeBuilder extends AbstractSessionTreeBuilder {
  constructor(protected sessionSelectorUtilsService: SessionSelectorUtilsService) {
    super(sessionSelectorUtilsService);
  }

  public buildTree(allSessions: Session[], context: ISessionSelectorContext): ISessionTreeNode[] {
    const selectableSessions =
      context.selectedSessionId && context.parentItemSessionId ? getSessionAndOneLevelChildren(allSessions, context.parentItemSessionId) : allSessions;
    let subTreeBuild = false;
    let filterWithHostId = !!context.parentItemSessionId;
    const subTreeRootLevelSessionId = this.sessionIdMap[context.selectedSessionId]?.parentId;

    // Whenever we have our goal aligned we want to show only our current session and its children
    if (context.parentItemSessionId && context.selectedSessionId) {
      const currentGoalAndParentItemAreInSharedSession = context.selectedSessionId === context.parentItemSessionId;
      filterWithHostId = currentGoalAndParentItemAreInSharedSession;
      subTreeBuild = allSessions.find((session) => session.id === context.parentItemSessionId)?.parentId && !currentGoalAndParentItemAreInSharedSession;
    }

    const rootLevelSessions = !subTreeBuild
      ? selectableSessions
          .filter((s) => !s.parentId || !this.sessionIdMap[s.parentId] || (filterWithHostId && s.id === context.selectedSessionId))
          .sort(this.sessionSelectorUtilsService.byEndDescAndStartAsc)
      : selectableSessions.filter((s) => s.id === subTreeRootLevelSessionId);

    const parentNodes = rootLevelSessions.map((session) =>
      this.createSessionTreeNode(session.id, { sessions: selectableSessions, hostSessionId: context.selectedSessionId })
    );

    const hostNode = this.findHostNode(parentNodes);
    return hostNode ? [hostNode, ...parentNodes.filter((n) => n.key !== hostNode.key)] : parentNodes;
  }

  protected findHostNode(sessionTree: ISessionTreeNode[]): ISessionTreeNode {
    return sessionTree.find((n) => n.isHostSession || n.hasChildHostSession);
  }
}
